import sanitizeFilename from "sanitize-filename";
import { useAbsoluteUrl } from "~/composables/useAbsoluteUrl";
import type { UseHeadInput, UseSeoMetaInput } from "@unhead/vue/types";

export default defineNuxtPlugin(() => {
  function valid(url: string) {
    try {
      const object = new URL(url);
      return object.protocol === "http:" || object.protocol === "https:";
    } catch (e) {
      return false;
    }
  }

  return {
    provide: {
      url: { valid }
    }
  };
});
